function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M155.927273 667.927273l-32.581818-32.581818 176.872727-176.872728 162.909091 116.363637 172.218182-172.218182 158.254545-132.654546 179.2 202.472728-37.236364 32.581818-146.618181-169.890909-123.345455 102.4-197.818182 197.818182-162.909091-116.363637z",
  fill: "#82A7C4"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1014.690909 889.018182l-69.818182-46.545455c-11.636364-6.981818-25.6-4.654545-32.581818 6.981818s-4.654545 25.6 6.981818 32.581819l6.981818 4.654545H46.545455V193.163636l4.654545 6.981819c6.981818 9.309091 20.945455 11.636364 32.581818 4.654545 9.309091-6.981818 11.636364-20.945455 4.654546-32.581818l-46.545455-69.818182c-4.654545-6.981818-16.290909-11.636364-25.6-9.309091-9.309091 4.654545-16.290909 13.963636-16.290909 23.272727v791.272728c0 13.963636 9.309091 23.272727 23.272727 23.272727h977.454546c9.309091 0 18.618182-6.981818 23.272727-16.290909 2.327273-9.309091-2.327273-20.945455-9.309091-25.6z",
  fill: "#e6e6e6",
  "data-spm-anchor-id": "a313x.7781069.0.i12",
  className: "selected"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116.363636 756.363636c-6.981818 0-11.636364-4.654545-11.636363-11.636363v-186.181818c0-6.981818 4.654545-11.636364 11.636363-11.636364h69.818182c6.981818 0 11.636364 4.654545 11.636364 11.636364v186.181818c0 6.981818-4.654545 11.636364-11.636364 11.636363H116.363636z",
  fill: "#F26A56"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M186.181818 535.272727H162.909091v-58.181818c0-6.981818-4.654545-11.636364-11.636364-11.636364s-11.636364 4.654545-11.636363 11.636364V535.272727H116.363636c-13.963636 0-23.272727 9.309091-23.272727 23.272728v186.181818c0 13.963636 9.309091 23.272727 23.272727 23.272727h23.272728v58.181818c0 6.981818 4.654545 11.636364 11.636363 11.636364s11.636364-4.654545 11.636364-11.636364V768h23.272727c13.963636 0 23.272727-9.309091 23.272727-23.272727v-186.181818c0-13.963636-9.309091-23.272727-23.272727-23.272728z m0 209.454546H116.363636v-186.181818h69.818182v186.181818z",
  fill: "#e6e6e6",
  "data-spm-anchor-id": "a313x.7781069.0.i13",
  className: "selected"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M442.181818 756.363636c-6.981818 0-11.636364-4.654545-11.636363-11.636363V465.454545c0-6.981818 4.654545-11.636364 11.636363-11.636363h69.818182c6.981818 0 11.636364 4.654545 11.636364 11.636363v279.272728c0 6.981818-4.654545 11.636364-11.636364 11.636363h-69.818182z",
  fill: "#3BB54A"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M512 442.181818h-23.272727v-58.181818c0-6.981818-4.654545-11.636364-11.636364-11.636364s-11.636364 4.654545-11.636364 11.636364V442.181818h-23.272727c-13.963636 0-23.272727 9.309091-23.272727 23.272727v279.272728c0 13.963636 9.309091 23.272727 23.272727 23.272727h23.272727v58.181818c0 6.981818 4.654545 11.636364 11.636364 11.636364s11.636364-4.654545 11.636364-11.636364V768h23.272727c13.963636 0 23.272727-9.309091 23.272727-23.272727V465.454545c0-13.963636-9.309091-23.272727-23.272727-23.272727z m0 302.545455h-69.818182V465.454545h69.818182v279.272728z",
  fill: "#e6e6e6",
  "data-spm-anchor-id": "a313x.7781069.0.i15",
  className: "selected"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M279.272727 570.181818c-6.981818 0-11.636364-4.654545-11.636363-11.636363v-139.636364c0-6.981818 4.654545-11.636364 11.636363-11.636364h69.818182c6.981818 0 11.636364 4.654545 11.636364 11.636364v139.636364c0 6.981818-4.654545 11.636364-11.636364 11.636363h-69.818182z",
  fill: "#3BB54A"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M349.090909 395.636364h-23.272727v-151.272728c0-6.981818-4.654545-11.636364-11.636364-11.636363s-11.636364 4.654545-11.636363 11.636363V395.636364h-23.272728c-13.963636 0-23.272727 9.309091-23.272727 23.272727v139.636364c0 13.963636 9.309091 23.272727 23.272727 23.272727h23.272728v151.272727c0 6.981818 4.654545 11.636364 11.636363 11.636364s11.636364-4.654545 11.636364-11.636364V581.818182h23.272727c13.963636 0 23.272727-9.309091 23.272727-23.272727v-139.636364c0-13.963636-9.309091-23.272727-23.272727-23.272727z m0 162.909091h-69.818182v-139.636364h69.818182v139.636364z",
  fill: "#e6e6e6",
  "data-spm-anchor-id": "a313x.7781069.0.i14",
  className: "selected"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M930.909091 570.181818c-6.981818 0-11.636364-4.654545-11.636364-11.636363v-139.636364c0-6.981818 4.654545-11.636364 11.636364-11.636364h69.818182c6.981818 0 11.636364 4.654545 11.636363 11.636364v139.636364c0 6.981818-4.654545 11.636364-11.636363 11.636363h-69.818182z",
  fill: "#3BB54A"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1000.727273 395.636364h-23.272728v-104.727273c0-6.981818-4.654545-11.636364-11.636363-11.636364s-11.636364 4.654545-11.636364 11.636364V395.636364h-23.272727c-13.963636 0-23.272727 9.309091-23.272727 23.272727v139.636364c0 13.963636 9.309091 23.272727 23.272727 23.272727h23.272727v104.727273c0 6.981818 4.654545 11.636364 11.636364 11.636363s11.636364-4.654545 11.636363-11.636363V581.818182h23.272728c13.963636 0 23.272727-9.309091 23.272727-23.272727v-139.636364c0-13.963636-9.309091-23.272727-23.272727-23.272727z m0 162.909091h-69.818182v-139.636364h69.818182v139.636364z",
  fill: "#e6e6e6",
  "data-spm-anchor-id": "a313x.7781069.0.i18",
  className: "selected"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M768 430.545455c-6.981818 0-11.636364-4.654545-11.636364-11.636364V186.181818c0-6.981818 4.654545-11.636364 11.636364-11.636363h69.818182c6.981818 0 11.636364 4.654545 11.636363 11.636363v232.727273c0 6.981818-4.654545 11.636364-11.636363 11.636364h-69.818182z",
  fill: "#3BB54A"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M837.818182 162.909091h-23.272727V104.727273c0-6.981818-4.654545-11.636364-11.636364-11.636364s-11.636364 4.654545-11.636364 11.636364V162.909091h-23.272727c-13.963636 0-23.272727 9.309091-23.272727 23.272727v232.727273c0 13.963636 9.309091 23.272727 23.272727 23.272727h23.272727v104.727273c0 6.981818 4.654545 11.636364 11.636364 11.636364s11.636364-4.654545 11.636364-11.636364V442.181818h23.272727c13.963636 0 23.272727-9.309091 23.272727-23.272727V186.181818c0-13.963636-9.309091-23.272727-23.272727-23.272727z m0 256h-69.818182V186.181818h69.818182v232.727273z",
  fill: "#e6e6e6",
  "data-spm-anchor-id": "a313x.7781069.0.i17",
  className: "selected"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M605.090909 500.363636c-6.981818 0-11.636364-4.654545-11.636364-11.636363v-162.909091c0-6.981818 4.654545-11.636364 11.636364-11.636364h69.818182c6.981818 0 11.636364 4.654545 11.636364 11.636364v162.909091c0 6.981818-4.654545 11.636364-11.636364 11.636363h-69.818182z",
  fill: "#F26A56"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M674.909091 302.545455h-23.272727v-58.181819c0-6.981818-4.654545-11.636364-11.636364-11.636363s-11.636364 4.654545-11.636364 11.636363V302.545455h-23.272727c-13.963636 0-23.272727 9.309091-23.272727 23.272727v162.909091c0 13.963636 9.309091 23.272727 23.272727 23.272727h23.272727v58.181818c0 6.981818 4.654545 11.636364 11.636364 11.636364s11.636364-4.654545 11.636364-11.636364V512h23.272727c13.963636 0 23.272727-9.309091 23.272727-23.272727v-162.909091c0-13.963636-9.309091-23.272727-23.272727-23.272727z m0 186.181818h-69.818182v-162.909091h69.818182v162.909091z",
  fill: "#e6e6e6",
  "data-spm-anchor-id": "a313x.7781069.0.i16",
  className: "selected"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    t: 1576305524833,
    className: "icon",
    viewBox: "0 0 1024 1024",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

export default __webpack_public_path__ + "static/media/graph.37029eff.svg";
export { SvgComponent as ReactComponent };